import { SVGProps } from "react";

export const SvgErrorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={52}
    height={48}
    fill="none"
    viewBox="0 0 52 48"
    {...props}
  >
    <path fill="#111" d="M17.75 14.5H33.5V42H17.75V14.5Z" />
    <g filter="url(#a)">
      <path
        fill="url(#b)"
        d="M5.46 47.199h41.09a5.455 5.455 0 0 0 4.718-8.185L30.724 3.519a5.456 5.456 0 0 0-9.438 0L.742 39.014c-2.104 3.63.516 8.184 4.719 8.184Z"
      />
    </g>
    <ellipse
      cx={26}
      cy={36.289}
      fill="#111"
      opacity={0.89}
      rx={2.719}
      ry={2.727}
    />
    <path
      fill="#111"
      d="M24.078 29.298c.512.51 1.204.799 1.927.8a2.736 2.736 0 0 0 2.73-2.725v-7.46a2.736 2.736 0 0 0-2.73-2.725 2.736 2.736 0 0 0-2.73 2.726v7.46c.003.722.292 1.414.803 1.924Z"
      opacity={0.89}
    />
    <defs>
      <linearGradient
        id="b"
        x1={6.75}
        x2={29.25}
        y1={43.25}
        y2={6.25}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB932" />
        <stop offset={1} stopColor="#FFD12E" />
      </linearGradient>
      <filter
        id="a"
        width={52}
        height={46.397}
        x={0}
        y={0.802}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset />
        <feGaussianBlur stdDeviation={1} />
        <feComposite in2="hardAlpha" k2={-1} k3={1} operator="arithmetic" />
        <feColorMatrix values="0 0 0 0 0.997178 0 0 0 0 0.694212 0 0 0 0 0.083826 0 0 0 1 0" />
        <feBlend in2="shape" result="effect1_innerShadow_1_10" />
      </filter>
    </defs>
  </svg>
);
